import React, { useState, useEffect } from 'react';
import { View } from './profile/view';
import toast from 'react-hot-toast';
import { getProfile } from '../../backend-services/profile';
import PageLoader from '../common/PageLoader';
import { GroupButton } from '../common';
import EditIcon from '../../assets/icons/EditIcon';
import { CreateEditProfile } from './profile/Edit';
import { useNavigate } from 'react-router-dom';
import { ICreateProfile } from '../../@types';

interface FormData {
  firstName: string;
  lastName: string;
  businessName: string;
  industry: string;
  email: string;
  phone: string;
  address: string;
  state: string;
  city: string;
  businessSize: string;
  brandLogo: string | ArrayBuffer | null;
  brandColor: string;
}



export const ViewProfile = () => {
   const [isLoading, setIsLoading] = React.useState<boolean>(false);
   const [showEditProfile, setShowEditProfile] = useState<boolean>(false);
   const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    businessName: '',
    email: '',
    phone: '',
    industry: '',
    address: '',
    state: '',
    city:'',
    businessSize: '',
    brandLogo: '',
    brandColor: '',
  });


  const getProfileHandler = async () => {
    setIsLoading(true);
    try {
      const data = await getProfile();
      setIsLoading(false);
      console.log("Retrieved data:", data); 
      setFormData(data);
    } catch (error: any) {
      setIsLoading(false);
      if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        navigate('/error');
      }
    }
  }
 
  React.useEffect(() => {
    getProfileHandler();
  }, []);

  
  const handleUpdatedProfileData = (updatedData: ICreateProfile) => {
    console.log("Updated data:", updatedData);
    if (typeof updatedData.brandLogo === 'string' || updatedData.brandLogo === undefined || updatedData.brandLogo === null) {
      setFormData({
        firstName: updatedData.firstName,
        lastName: updatedData.lastName,
        businessName: updatedData.businessName,
        email: updatedData.email,
        phone: updatedData.phone,
        industry: updatedData.industry,
        address: updatedData.address,
        state: updatedData.state,
        city: updatedData.city,
        businessSize: updatedData.businessSize,
        brandLogo: updatedData.brandLogo as string, 
        brandColor: updatedData.brandColor as string,
      });
    } else {
    }
  };
  
  return (
    <>
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          
          <div className='flex flex-col justify-center items-center md:items-stretch md:justify-start'>
            <div className="bg-[#FFFFFF] mx-[-50px] md:mx-0 rounded-[7px] lg:mt-[-1em] xl:mt-[-1em] md:mt-[-1em] mt-[-1.4em]">
            <div className="flex items-center gap-[36px] md:pl-[20px] md:pt-[55px]">
              <div className="flex flex-col gap-[7px] pt-[13px] pl-[20px]">
                <h3 className="text-[16px] md:text-[20px] text-[#00000]leading-6 font-semibold">Profile information</h3>
                <p className="text-[12px] md:text-[16px] md:leading-5 font-normal">View and edit your profile information</p>
              </div>
              <a
                href="#edit-modal"
                className="inline-flex items-center text-[#044E97] font-medium mt-[0rem] text-[20px] lg:text-[15px] xl:mt-[1rem] pr-[20px] lg:pl-[20px]"
                onClick={() => setShowEditProfile(true)}
              >
                <div className='mt-[1em]'>
                <GroupButton
                  buttons={[
                    {
                      text: 'Edit',
                      icon: <EditIcon />,
                      href: '',
                    },
                  ]}
                />
                </div>
              
              </a>
            </div>
            
          <div className=''>
        <View formData={formData} />
          </div>

          </div>
          </div>
        </>
      )}
        <CreateEditProfile show={showEditProfile} onClose={() => setShowEditProfile(false)} onCreateEditProfile={handleUpdatedProfileData} />
    </>
  );
    }
